import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import Finance from "./pages/Finance";
import FinanceDetail from "./pages/FinanceDetail";
import Sales from "./pages/Sales";
import Customers from "./pages/Customers";
import CustomerDetail from "./pages/CustomerDetail";
import CashierShift from "./pages/CashierShift";
import Reports from "./pages/Reports";
import Inventory from "./pages/Inventory";
import StockConversion from "./pages/StockConversion";
import MasterData from "./pages/MasterData";
import ProductDetail from "./pages/ProductDetail";
import ProductDetailApps from "./pages/ProductDetail/ProductDetailApps";
import InventoryDetail from "./pages/InventoryDetail";
import StockDetail from "./pages/StockDetail";
import StockLocationDetail from "./pages/StockLocationDetail";
import ServiceDetail from "./pages/ServiceDetail";
import UnitDetail from "./pages/UnitDetail";
import Configuration from "./pages/Configuration";
import ActivationManagement from "./pages/ActivationManagement";
import Login from "./pages/Login";
import NotaPO from "./pages/NotaPO";
import NotaReceiving from "./pages/NotaReceiving";
import ComingSoon from "./pages/ComingSoon";
import Profile from "./pages/Profile";
import { EcatalogCatalog, EcatalogDiscovery } from "./pages/Ecatalog/Ecatalog";

// Admin components
import AdminDashboard from "./pages/AdminDashboard";
import AdminHome from "./pages/AdminHome";
import UserManagement from "./pages/UserManagement";
import TenantManagement from "./pages/TenantManagement";
import TenantAuditTrail from "./pages/TenantAuditTrail";
import AdminSettings from "./pages/AdminSettings";

import RequireAuth from "./components/RequireAuth";
import RequireAdmin from "./components/RequireAdmin";
import InstallPrompt from "./components/InstallPrompt";
import SelectTenant from "./pages/SelectTenant";
import { NotificationProvider } from "./contexts/NotificationContext";
import { SidebarConfigProvider } from "./contexts/SidebarConfigContext";
import "./App.css";

function App() {
  return (
    <NotificationProvider>
      <SidebarConfigProvider>
        <Routes>
          <Route path="/e-katalog" element={<EcatalogDiscovery />} />
          <Route path="/e-katalog/:slug" element={<EcatalogCatalog />} />
          <Route
            path="/"
            element={
              <RequireAuth>
                <Home />
              </RequireAuth>
            }
          />
          <Route path="/login" element={<Login />} />
          <Route
            path="/select-tenant"
            element={
              <RequireAuth>
                <SelectTenant />
              </RequireAuth>
            }
          />
          <Route
            path="/dashboard"
            element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/keuangan"
            element={
              <RequireAuth>
                <Finance />
              </RequireAuth>
            }
          />
          <Route
            path="/keuangan/:id"
            element={
              <RequireAuth>
                <FinanceDetail />
              </RequireAuth>
            }
          />
          <Route
            path="/penjualan"
            element={
              <RequireAuth>
                <Sales />
              </RequireAuth>
            }
          />
          <Route
            path="/pelanggan"
            element={
              <RequireAuth>
                <Customers />
              </RequireAuth>
            }
          />
          <Route
            path="/pelanggan/:id"
            element={
              <RequireAuth>
                <CustomerDetail />
              </RequireAuth>
            }
          />
          <Route
            path="/shift-kasir"
            element={
              <RequireAuth>
                <CashierShift />
              </RequireAuth>
            }
          />
          <Route
            path="/inventori"
            element={
              <RequireAuth>
                <Inventory />
              </RequireAuth>
            }
          />
          <Route
            path="/inventori/persediaan"
            element={
              <RequireAuth>
                <Inventory />
              </RequireAuth>
            }
          />
          <Route
            path="/inventori/penyesuaian"
            element={
              <RequireAuth>
                <Inventory />
              </RequireAuth>
            }
          />
          <Route
            path="/inventori/purchase-orders"
            element={
              <RequireAuth>
                <Inventory />
              </RequireAuth>
            }
          />
          <Route
            path="/inventori/po"
            element={
              <RequireAuth>
                <Inventory />
              </RequireAuth>
            }
          />
          <Route
            path="/inventori/permintaan"
            element={
              <RequireAuth>
                <Inventory />
              </RequireAuth>
            }
          />
          <Route
            path="/inventori/pengadaan"
            element={
              <RequireAuth>
                <Inventory />
              </RequireAuth>
            }
          />
          <Route
            path="/inventori/penerimaan"
            element={
              <RequireAuth>
                <Inventory />
              </RequireAuth>
            }
          />
          <Route
            path="/inventori/konversi"
            element={
              <RequireAuth>
                <Inventory />
              </RequireAuth>
            }
          />
          <Route
            path="/inventori/label-barcode"
            element={
              <RequireAuth>
                <Inventory />
              </RequireAuth>
            }
          />
          <Route
            path="/inventori/konversi/stok"
            element={
              <RequireAuth>
                <Inventory />
              </RequireAuth>
            }
          />
          <Route
            path="/inventori/konversi/aturan"
            element={
              <RequireAuth>
                <Inventory />
              </RequireAuth>
            }
          />
          <Route
            path="/inventori/stok-ekstra"
            element={
              <RequireAuth>
                <Inventory />
              </RequireAuth>
            }
          />
          <Route
            path="/master-data/produk"
            element={
              <RequireAuth>
                <MasterData />
              </RequireAuth>
            }
          />
          <Route
            path="/master-data/label-barcode"
            element={
              <RequireAuth>
                <MasterData />
              </RequireAuth>
            }
          />
          <Route
            path="/master-data/addon"
            element={
              <RequireAuth>
                <MasterData />
              </RequireAuth>
            }
          />
          <Route
            path="/master-data/layanan"
            element={
              <RequireAuth>
                <MasterData />
              </RequireAuth>
            }
          />
          <Route
            path="/master-data/unit"
            element={
              <RequireAuth>
                <MasterData />
              </RequireAuth>
            }
          />
          <Route
            path="/master-data/merek"
            element={
              <RequireAuth>
                <MasterData />
              </RequireAuth>
            }
          />
          <Route
            path="/master-data/supplier"
            element={
              <RequireAuth>
                <MasterData />
              </RequireAuth>
            }
          />
          <Route
            path="/master-data/kategori"
            element={
              <RequireAuth>
                <MasterData />
              </RequireAuth>
            }
          />
          <Route
            path="/master-data/satuan"
            element={
              <RequireAuth>
                <MasterData />
              </RequireAuth>
            }
          />
          <Route
            path="/master-data/tipe-penjualan"
            element={
              <RequireAuth>
                <MasterData />
              </RequireAuth>
            }
          />
          <Route
            path="/master-data/meja"
            element={
              <RequireAuth>
                <MasterData />
              </RequireAuth>
            }
          />
          <Route
            path="/master-data/lokasi-stok"
            element={
              <RequireAuth>
                <MasterData />
              </RequireAuth>
            }
          />
          <Route
            path="/master-data/lokasi-stok/:id"
            element={
              <RequireAuth>
                <StockLocationDetail />
              </RequireAuth>
            }
          />
          <Route
            path="/master-data/produk/:id"
            element={
              <RequireAuth>
                <ProductDetail />
              </RequireAuth>
            }
          />
          <Route
            path="/master-data/produk/:id/preview-apps"
            element={
              <RequireAuth>
                <ProductDetailApps />
              </RequireAuth>
            }
          />
          <Route
            path="/inventori/permintaan/:id"
            element={
              <RequireAuth>
                <InventoryDetail />
              </RequireAuth>
            }
          />
          <Route
            path="/inventori/pengadaan/:id"
            element={
              <RequireAuth>
                <InventoryDetail />
              </RequireAuth>
            }
          />
          <Route
            path="/inventori/penerimaan/:id"
            element={
              <RequireAuth>
                <InventoryDetail />
              </RequireAuth>
            }
          />
          <Route
            path="/inventori/purchase-orders/:id"
            element={
              <RequireAuth>
                <InventoryDetail />
              </RequireAuth>
            }
          />
          <Route
            path="/inventori/purchase-orders/:id/print"
            element={
              <RequireAuth>
                <NotaPO />
              </RequireAuth>
            }
          />
          <Route
            path="/inventori/purchase-orders/:id/receiving/:rcvId/print"
            element={
              <RequireAuth>
                <NotaReceiving />
              </RequireAuth>
            }
          />
          <Route
            path="/inventori/receiving/:rcvId/print"
            element={
              <RequireAuth>
                <NotaReceiving />
              </RequireAuth>
            }
          />
          <Route
            path="/inventori/penerimaan/:rcvId/print"
            element={
              <RequireAuth>
                <NotaReceiving />
              </RequireAuth>
            }
          />
          <Route
            path="/inventori/po/:id"
            element={
              <RequireAuth>
                <InventoryDetail />
              </RequireAuth>
            }
          />
          <Route
            path="/inventori/nota-po/:id"
            element={
              <RequireAuth>
                <NotaPO />
              </RequireAuth>
            }
          />
          <Route
            path="/inventori/stok/:id"
            element={
              <RequireAuth>
                <StockDetail />
              </RequireAuth>
            }
          />
          <Route
            path="/inventori/layanan/:id"
            element={
              <RequireAuth>
                <ServiceDetail />
              </RequireAuth>
            }
          />
          <Route
            path="/inventori/unit/:id"
            element={
              <RequireAuth>
                <UnitDetail />
              </RequireAuth>
            }
          />
          <Route
            path="/laporan"
            element={
              <RequireAuth>
                <Reports />
              </RequireAuth>
            }
          />
          <Route
            path="/profile"
            element={
              <RequireAuth>
                <Profile />
              </RequireAuth>
            }
          />
          {/* Admin Routes */}
          <Route
            path="/admin"
            element={
              <RequireAdmin>
                <AdminDashboard>
                  <AdminHome />
                </AdminDashboard>
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/users"
            element={
              <RequireAdmin>
                <AdminDashboard>
                  <UserManagement />
                </AdminDashboard>
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/tenants"
            element={
              <RequireAdmin>
                <AdminDashboard>
                  <TenantManagement />
                </AdminDashboard>
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/tenants/:tenantId/audit"
            element={
              <RequireAdmin>
                <AdminDashboard>
                  <TenantAuditTrail />
                </AdminDashboard>
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/settings"
            element={
              <RequireAdmin>
                <AdminDashboard>
                  <AdminSettings />
                </AdminDashboard>
              </RequireAdmin>
            }
          />
          <Route
            path="/konfigurasi"
            element={
              <RequireAuth>
                <Configuration />
              </RequireAuth>
            }
          />
          <Route
            path="/konfigurasi/manajemen-aktivasi"
            element={
              <RequireAuth>
                <ActivationManagement />
              </RequireAuth>
            }
          />
        </Routes>
        <InstallPrompt />
      </SidebarConfigProvider>
    </NotificationProvider>
  );
}

export default App;
